// Centralized ARC brand assets. Single source of truth so the ticker,
// hero, and any future surface all render the same coin logo.
// NOTE: This is a CDN URL, not a bundled file. The asset already ships
// with the project and is the exact image used by the Hero medallion.
export const ARC_COIN_LOGO_URL =
  "https://static.prod-images.emergentagent.com/jobs/756805e3-0bfe-493b-a89d-5ce6463cebd2/images/d3a4dace2efb875fed4a83dfb2762b45d8e0ab272c085d55f1411ae10ea0a329.png";
